import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        loginStatus: 0, //登录状态 0未登录 1已登陆
        addressInfo:"",//下单选择地址
        userInfo:{},//用户信息
        isChange:true,//是否添加或减少产品或生成订单，用于刷新购物车
        isNewChange:false,//是否删除购物车产品或在购物车修改过或生成订单
        productInfo:"",//产品信息
        couponInfo:"",//优惠券信息
        couponList:[],//可使用优惠券列表
        cartList:[],//生成订单产品信息
        zdqpFb:0,//是否允许最低起批翻倍，0、关闭 1、开启
        priceDecimal:0,//商品列表，单价保留小数位
        moneyDecimal:0,//商品列表，金额保留小数位
        numDecimal:0,//商品列表，数量保留小数位
        isUpdate:-1,
        isSearch:false,//判断是否是从其他页面跳到分类来搜索产品
        cartTotal:10,//购物车品种数
        scrollTop:0,
        pageHeight:0,
        couponIndex:0,//区分联盟商户选优惠券
    },
    mutations:{
        setCouponIndex(state, payload){
            state.couponIndex = payload;
        },
        setPageHeight(state, payload){
            state.pageHeight = payload;
        },
        set_scrollTop(state, payload){
            state.scrollTop = payload;
        },
        //更改购物车品种数
        setCartTotal(state, payload){
            state.cartTotal = payload;
        },
         //更改修改还是创建状态
         setIsSearch(state, payload) {
			state.isSearch = payload;
        },
         //更改修改还是创建状态
         setIsUpdate(state, payload) {
			state.isUpdate = payload;
        },
        //更改登陆状态
        setLoginStatus(state, payload) {
			state.loginStatus = payload;
        },
        //更改下单选择地址
        setAddressInfo(state,payload){
            state.addressInfo = payload;
        },
         //更改用户信息
         setUserInfo(state,payload){
            state.userInfo = payload;
        },
        //更改产品信息
        setProductInfo(state,payload){
            state.productInfo = payload;
        },
        //更改修改产品状态
        setIsChange(state,payload){
            state.isChange = payload;
        },
         //更改修改购物车状态
         setIsNewChange(state,payload){
            state.isNewChange = payload;
        },
        //更改优惠券信息
        setCouponInfo(state,payload){
            state.couponInfo = payload;
        },
        //更改可使用优惠券列表
        setCouponList(state,payload){
            state.couponList = payload;
        },
        //更改最低起批翻倍
        setFb(state,payload){
            state.zdqpFb = payload;
        },
        //更改单价保留小数位
        setPrice(state,payload){
            state.priceDecimal = payload;
        },
        //更改金额保留小数位
        setMoney(state,payload){
            state.moneyDecimal = payload;
        },
        //更改数量保留小数位
        setNum(state,payload){
            state.numDecimal = payload;
        },
        //更改生成订单购物车产品
        setCartList(state,payload){
            state.cartList = payload;
        },
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js